import React from "react";
import PropTypes from "prop-types";
import SFTypography from "../typography";
import { SFStack } from "../grid";

const FilterChipLabel = ({ label, value }) => {
  return (
    <SFStack direction="row" alignItems="center">
      <SFTypography variant="textValue" className="label">
        {label}
      </SFTypography>
      {value && (
        <SFTypography variant="textValue" className="value">
          {value}
        </SFTypography>
      )}
    </SFStack>
  );
};

FilterChipLabel.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default FilterChipLabel;
